(function () {
    'use strict';

    angular.module("imApp").factory("productCategoryLangService", ['$ihttp', function ($ihttp) {
        let service = {
            listProductCategoryLanguages: function (parms) {
                return $ihttp.post({
                    method: 2713,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2714,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
